import axios from 'axios'
import { attachAuthRefresh } from './authInterceptor'
import { attachInstitutionScope } from './institutionInterceptor'


const fallbackUrl = 'https://sys.chu.kg/api/'
const envUrl = process.env.REACT_APP_API_URL
if (!envUrl && process.env.NODE_ENV === 'production') {
  
  console.error(
    '[CHU] REACT_APP_API_URL не задан в production-сборке (apiJSON).',
  )
}
export const API_URL = envUrl || fallbackUrl

export const $apiJSON = axios.create({
  withCredentials: true,
  baseURL: API_URL,
})

// 401 → refresh → retry; при провале — clear + redirect /login.
attachAuthRefresh($apiJSON)
attachInstitutionScope($apiJSON)

export default $apiJSON
